import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { AuthCard } from "@/components/AuthCard";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pwd, setPwd] = useState("");
  const [confirm, setConfirm] = useState("");
  const [done, setDone] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pwd.length < 8) return setError("Le mot de passe doit contenir au moins 8 caractères");
    if (pwd !== confirm) return setError("Les deux mots de passe ne correspondent pas");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/reset-password", { token, password: pwd });
      setDone(data.message);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthCard subtitle="Nouveau mot de passe">
      {done ? (
        <div className="space-y-5" data-testid="reset-done">
          <p className="flex gap-2 rounded-lg bg-primary/10 px-3 py-3 text-sm"><CheckCircle2 className="h-5 w-5 shrink-0 text-primary" /> {done}</p>
          <Button asChild className="w-full"><Link to="/login" data-testid="reset-login-link">Se connecter</Link></Button>
        </div>
      ) : !token ? (
        <p className="rounded-lg bg-destructive/15 px-3 py-2 text-sm text-destructive" data-testid="reset-no-token">
          Lien incomplet. <Link to="/forgot-password" className="underline">Refaire une demande</Link>
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="reset-form">
          <div className="space-y-2">
            <Label htmlFor="pwd">Nouveau mot de passe (8 caractères minimum)</Label>
            <Input id="pwd" type="password" value={pwd} onChange={(e) => setPwd(e.target.value)} required data-testid="reset-password-input" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="confirm">Confirmer le mot de passe</Label>
            <Input id="confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm-input" />
          </div>
          {error && (
            <p className="rounded-lg bg-destructive/15 px-3 py-2 text-sm text-destructive" data-testid="reset-error">
              {error} {error.includes("expiré") && <Link to="/forgot-password" className="underline">Refaire une demande</Link>}
            </p>
          )}
          <Button type="submit" className="w-full" disabled={loading} data-testid="reset-submit-button">
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Enregistrer le mot de passe
          </Button>
        </form>
      )}
    </AuthCard>
  );
}
